const content = [require("./2/index").default];

export default content;
